import template from './environment_config.all.html';
import controller from './environment_config.all.controller';
import './environment_config.all.scss';

const environmentConfigAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default environmentConfigAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/all/environment_config.all.component.js